import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import type { ExtraConfig } from '@gov-nx/core/app/extra-config/context.types';
import { is } from '@gov-nx/core/types/helpers.types';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const ROBPage = lazy(() =>
	import('./ROBPage').then(({ ROBPage }) => ({ default: ROBPage }))
);
const ROSPage = lazy(() =>
	import('./ROSPage').then(({ ROSPage }) => ({ default: ROSPage }))
);

const ROSDetailPage = lazy(() =>
	import('./ROSDetailPage').then(({ ROSDetailPage }) => ({
		default: ROSDetailPage,
	}))
);

const CertificatesPage = lazy(() =>
	import('./CertificatesPage').then(({ CertificatesPage }) => ({
		default: CertificatesPage,
	}))
);
const EDocumentsPage = lazy(() =>
	import('./EDocumentsPage').then(({ EDocumentsPage }) => ({
		default: EDocumentsPage,
	}))
);
const PassportPage = lazy(() =>
	import('./PassportPage').then(({ PassportPage }) => ({
		default: PassportPage,
	}))
);
const IDPage = lazy(() =>
	import('./IDPage').then(({ IDPage }) => ({ default: IDPage }))
);
const DriversLicensePage = lazy(() =>
	import('./DriversLicensePage').then(({ DriversLicensePage }) => ({
		default: DriversLicensePage,
	}))
);
const DocumentsPage = lazy(() =>
	import('./DocumentsPage').then(({ DocumentsPage }) => ({
		default: DocumentsPage,
	}))
);
const MyOwnDocumentPage = lazy(() =>
	import('./MyOwnDocumentPage').then(({ MyOwnDocumentPage }) => ({
		default: MyOwnDocumentPage,
	}))
);

export const getProfileRoutes = (
	extraConfig: ExtraConfig['profileRoutes']
): RouteObject[] => [
	{
		path: getPagePartSlug('profil'),
		children: [
			{
				path: getPagePartSlug('profil.rob'),
				element: (
					<AuthorizedRoute>
						<ROBPage {...extraConfig.robConfig} />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('profil.edoklady'),
				element: (
					<AuthorizedRoute>
						<EDocumentsPage {...extraConfig.eDokladyConfig} />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('profil.ros'),
				children: [
					{
						index: true,
						element: (
							<AuthorizedRoute>
								<ROSPage {...extraConfig.rosConfig} />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('profil.ros.detail'),
						element: (
							<AuthorizedRoute>
								<ROSDetailPage {...extraConfig.rosDetailConfig} />
							</AuthorizedRoute>
						),
					},
				],
			},
			{
				path: getPagePartSlug('profil.certifikaty'),
				element: (
					<AuthorizedRoute>
						<CertificatesPage {...extraConfig.certifikatyConfig} />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('profil.doklady'),
				children: [
					{
						index: true,
						element: (
							<AuthorizedRoute>
								<DocumentsPage {...extraConfig.dokladyConfig} />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('profil.doklady.cestovni-pas'),
						element: (
							<AuthorizedRoute>
								<PassportPage />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('profil.doklady.obcansky-prukaz'),
						element: (
							<AuthorizedRoute>
								<IDPage />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('profil.doklady.ridicsky-prukaz'),
						element: (
							<AuthorizedRoute>
								<DriversLicensePage />
							</AuthorizedRoute>
						),
					},
					{
						path: getPagePartSlug('profil.doklady.vlastni-doklad'),
						element: (
							<AuthorizedRoute>
								<MyOwnDocumentPage />
							</AuthorizedRoute>
						),
					},
				],
			},
		].filter(is),
	},
];
